import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useChatStore } from '../stores/chatStore';
import ChatInput from '../components/ChatInput';
import MessageList from '../components/MessageList';
import WelcomeScreen from '../components/WelcomeScreen';

export default function ChatPage() {
  const { chatId } = useParams<{ chatId: string }>();
  const { currentChat, loadChat, createChat } = useChatStore();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chatId) {
      loadChat(chatId);
    }
  }, [chatId, loadChat]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  if (!chatId && !currentChat) {
    return (
      <div className="h-full flex flex-col">
        <WelcomeScreen onNewChat={createChat} />
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      {/* Chat Header */}
      {currentChat && (
        <div className="h-14 border-b border-legion-border flex items-center px-6 shrink-0">
          <h2 className="font-medium text-lg truncate">{currentChat.title}</h2>
        </div>
      )}

      {/* Messages */}
      <div className="flex-1 overflow-y-auto">
        <MessageList onScrollToBottom={scrollToBottom} />
        <div ref={messagesEndRef} />
      </div>

      {/* Input */}
      <div className="border-t border-legion-border p-4 shrink-0">
        <ChatInput />
      </div>
    </div>
  );
}
